<!--
 * @Author: chenyn 1826650603@qq.com
 * @Date: 2023-09-12 11:07:55
 * @LastEditors: chenyn 1826650603@qq.com
 * @LastEditTime: 2023-10-23 15:24:12
 * @FilePath: \smart-campus-platform-front-vue\src\views\homepage\resource\album-detail.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <ItcDetail v-if=" id > 84" />
    <RoutineDetail v-else />
  </div>
</template>

<script>
import ItcDetail  from "./album-detail/itc-album-detail.vue"
import RoutineDetail  from "./album-detail/routine-album-detail.vue"
export default {
  data(){
    return {
      id:  parseInt(this.$route.query.id),
      
    }
  },
  created() {},
  components: {
    ItcDetail,
    RoutineDetail,
  },
  computed: {
    isTencentCloud() {
      return sessionStorage.getItem("tencentCloud") === "1" ? true : false;
    },
    // id() {
    //   return parseInt(this.$route.query.id)
    // }
  },
  methods: {}
}
</script>

<style scoped lang='scss'>
</style>
